var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import classNames from 'classnames';
import _ from 'lodash';
import Expectation from './Expectation';
import Stoplight from './Stoplight';
var Expectations = /** @class */ (function (_super) {
    __extends(Expectations, _super);
    function Expectations(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { open: true };
        _this.toggleOpen = _this.toggleOpen.bind(_this);
        return _this;
    }
    Expectations.prototype.getExpectations = function () {
        return _.map(this.props.expectations, function (expectation) {
            return (_jsx(Expectation, { goal: expectation.goal, actual: expectation.actual, frequency: expectation.frequency, isCurrency: expectation.isCurrency, productName: expectation.productName }, expectation.key));
        });
    };
    Expectations.prototype.getContent = function () {
        var result = '';
        if (this.state.open) {
            return (_jsx("div", { className: "sb-expectations-guts show", children: this.getExpectations() }));
        }
        return result;
    };
    Expectations.prototype.getHeader = function () {
        var _a, _b;
        var toggleClass = this.state.open ? 'ion-arrow-up-b' : 'ion-arrow-down-b';
        var toggle = (_jsx("span", { className: "sb-expectations-toggle", onClick: this.toggleOpen, children: _jsx("i", { className: toggleClass }) }));
        if (this.props.isCoachsArea) {
            return (_jsxs("header", { className: "sb-expectations-header", children: [_jsx("img", { className: "sb-expectations-profile-pic", src: (_a = this.props.playerInfo) === null || _a === void 0 ? void 0 : _a.profilePic, alt: "Profile pic" }), _jsx(Stoplight, { lowestPercentComplete: this.props.lowestPercentComplete }), _jsx("span", { className: "sb-expectations-header-title", children: (_b = this.props.playerInfo) === null || _b === void 0 ? void 0 : _b.name }), toggle] }));
        }
        return (_jsxs("header", { className: "sb-expectations-header", children: [_jsx("i", { className: "ion-flag" }), _jsx("span", { className: "sb-expectations-header-title", children: "My Expectations" }), _jsx(Stoplight, { lowestPercentComplete: this.props.lowestPercentComplete }), toggle] }));
    };
    Expectations.prototype.toggleOpen = function () {
        this.setState(function (prev) {
            return {
                open: !prev.open
            };
        });
    };
    Expectations.prototype.render = function () {
        var expectationCoach = classNames({
            'sb-expectations': true,
            'sb-expectations--coachs-area': this.props.isCoachsArea,
            'push-bottom': !this.props.isCoachsArea
        });
        return (_jsxs("div", { className: expectationCoach, children: [this.getHeader(), this.getContent()] }));
    };
    return Expectations;
}(React.Component));
export default Expectations;
